import PropTypes from 'prop-types';
import { activityMasteryPropTypeShape } from '../../../components/activity-status-bar/activity-mastery-prop-type';

const strengthWeaknessData = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    averageResult: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired
});

const activityMasteryData = PropTypes.shape({
    className: PropTypes.string,

    courseInfo: PropTypes.shape({
        ...activityMasteryPropTypeShape,

        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        totalTests: PropTypes.number.isRequired
    }).isRequired,

    topicActivityResults: PropTypes.arrayOf(
        PropTypes.shape({
            ...activityMasteryPropTypeShape,

            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            totalAssignedActivities: PropTypes.number.isRequired,

            activityResultDetails: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    name: PropTypes.string.isRequired,
                    result: PropTypes.number.isRequired,
                    attempts: PropTypes.number.isRequired,
                    hasGoldBar: PropTypes.bool.isRequired,
                    isAssigned: PropTypes.bool.isRequired
                })
            ).isRequired
        })
    ).isRequired,

    testResults: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            result: PropTypes.number.isRequired,
            attempts: PropTypes.number.isRequired
        })
    ).isRequired,

    strengths: PropTypes.shape({
        topics: PropTypes.arrayOf(strengthWeaknessData),
        activities: PropTypes.arrayOf(strengthWeaknessData)
    }).isRequired,

    weaknesses: PropTypes.shape({
        topics: PropTypes.arrayOf(strengthWeaknessData),
        activities: PropTypes.arrayOf(strengthWeaknessData)
    }).isRequired
});

export default {
    activityMasteryData
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/student/student-prop-types.js